<script>
import BasketItemAvailable from './basket-item-available.vue';

export default {
	components: {
		BasketItemAvailable
	},
	props: {
		basketItem: {
			type: Object,
			required: true
		}
	}
};
</script>

<template>
	<BasketItemAvailable :basket-item="basketItem"/>
</template>

<style scoped>
</style>
